import dayjs from 'dayjs';
import jsCookies from 'js-cookie';
import { useState } from 'react';

import {
  COOKIE_KEY_DESKTOP_PTO_COUNTER_TIMER,
  COOKIE_KEY_DESKTOP_PTO_POPUP_CLOSE_STATUS,
  COOKIE_VALUE_DESKTOP_PTO_COUNTER_TIMER_END,
  COOKIE_VALUE_DESKTOP_PTO_POPUP_CLOSED,
} from './constants';
import { PtoAdModal as DesktopPtoAdModal } from './modal/desktop';
import { PtoAdModal as MobilePtoAdModal } from './modal/mobile';
import { Trigger as PtoPopupTrigger } from './trigger';
import type { UpdatePtoAdsData } from './trigger/mobile';
import type { Component } from './types';

export const PtoAds: Component = () => {
  const [isMobilePtoAdModalOpen, setIsMobilePtoAdModalOpen] = useState(false);
  const [
    mobilePtoAdData,
    setMobilePtoAdData,
  ] = useState<UpdatePtoAdsData | null >(null);
  const [isDesktopPtoAdModalOpen, setIsDesktopPtoAdModalOpen] = useState(false);

  const isDesktopPtoModalOpenedBefore = jsCookies.get(
    COOKIE_KEY_DESKTOP_PTO_POPUP_CLOSE_STATUS,
  ) === COOKIE_VALUE_DESKTOP_PTO_POPUP_CLOSED;
  const isDesktopPtoModalCounterTimerEnd = jsCookies.get(
    COOKIE_KEY_DESKTOP_PTO_COUNTER_TIMER,
  ) === COOKIE_VALUE_DESKTOP_PTO_COUNTER_TIMER_END;

  return (
    <>
      {
        !isDesktopPtoModalOpenedBefore && (
          <PtoPopupTrigger
            onDesktopTrigger={() => {
              setIsDesktopPtoAdModalOpen(true);
            }}
            onMobileTrigger={({
              mobilePtoCreative,
              mobilePtoUrl,
            }) => {
              setMobilePtoAdData({
                mobilePtoCreative,
                mobilePtoUrl,
              });
              setIsMobilePtoAdModalOpen(true);
            }} />
        )
      }
      <DesktopPtoAdModal
        backdropTransitionDurationMs={200}
        hasCloseCountdown={!isDesktopPtoModalCounterTimerEnd}
        isOpen={isDesktopPtoAdModalOpen}
        onClose={() => {
          const ptoCookieExpireDate = dayjs()
            .hour(23)
            .minute(59)
            .second(59)
            .toDate();

          setIsDesktopPtoAdModalOpen(false);

          jsCookies.set(
            COOKIE_KEY_DESKTOP_PTO_POPUP_CLOSE_STATUS,
            COOKIE_VALUE_DESKTOP_PTO_POPUP_CLOSED,
            {
              expires: ptoCookieExpireDate,
            },
          );
          jsCookies.set(
            COOKIE_KEY_DESKTOP_PTO_COUNTER_TIMER,
            COOKIE_VALUE_DESKTOP_PTO_COUNTER_TIMER_END,
            {
              expires: ptoCookieExpireDate,
            },
          );
        }} />
      <MobilePtoAdModal
        adImageSrc={mobilePtoAdData?.mobilePtoCreative ?? ''}
        adLink={mobilePtoAdData?.mobilePtoUrl ?? ''}
        backdropTransitionDurationMs={200}
        isOpen={isMobilePtoAdModalOpen}
        onClose={() => {
          setIsMobilePtoAdModalOpen(false);
        }} />
    </>
  );
};
